import React from 'react';
import _ from 'lodash';

import { ListHeaderItem } from 'models/commonModel';

interface Props {
  headerItems: ListHeaderItem<any>[];
  truncateWidth?: number;
  hasActions?: boolean;
}

const CustomStatusListHeader = ({ headerItems, truncateWidth = 200, hasActions = false }: Props) => {
  return (
    <tr>
      {headerItems.map((headerItem) => (
        <th key={headerItem.id as string} className='p-2' scope="col">
          <div className="fw-bold d-flex align-items-center justify-content-between">
            <span className={`truncate-width-${truncateWidth}`} title={headerItem.label}>
              {headerItem.label}
            </span>
          </div>
        </th>
      ))}
      {hasActions && <th scope="col"></th>}
    </tr>
  );
};

export default React.memo(CustomStatusListHeader, (prev, next) => _.isEqual(prev, next));
